/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import { ELEMENTS_CONTEXT, FabricElementsAnalyticsContext } from '@atlaskit/analytics-namespaced-context/FabricElementsAnalyticsContext'` instead.
 */
export { ELEMENTS_CONTEXT, FabricElementsAnalyticsContext } from './FabricElementsAnalyticsContext';

/**
 * @deprecated Use `import { NAVIGATION_CONTEXT, NavigationAnalyticsContext } from '@atlaskit/analytics-namespaced-context/NavigationAnalyticsContext'` instead.
 */
export { NAVIGATION_CONTEXT, NavigationAnalyticsContext } from './NavigationAnalyticsContext';

/**
 * @deprecated Use `import { EDITOR_CONTEXT, EDITOR_APPEARANCE_CONTEXT, FabricEditorAnalyticsContext } from '@atlaskit/analytics-namespaced-context/FabricEditorAnalyticsContext'` instead.
 */
export {
	EDITOR_CONTEXT,
	EDITOR_APPEARANCE_CONTEXT,
	FabricEditorAnalyticsContext,
} from './FabricEditorAnalyticsContext';

/**
 * @deprecated Use `import { MEDIA_CONTEXT } from '@atlaskit/analytics-namespaced-context/MediaAnalyticsContext'` instead.
 */
export { MEDIA_CONTEXT } from './MediaAnalyticsContext';

/**
 * @deprecated Use `import { PEOPLE_TEAMS_CONTEXT, PeopleTeamsAnalyticsContext } from '@atlaskit/analytics-namespaced-context/PeopleTeamsAnalyticsContext'` instead.
 */
export { PEOPLE_TEAMS_CONTEXT, PeopleTeamsAnalyticsContext } from './PeopleTeamsAnalyticsContext';

/**
 * @deprecated Use `import { NOTIFICATIONS_CONTEXT, NotificationsAnalyticsContext } from '@atlaskit/analytics-namespaced-context/NotificationsAnalyticsContext'` instead.
 */
export {
	NOTIFICATIONS_CONTEXT,
	NotificationsAnalyticsContext,
} from './NotificationsAnalyticsContext';

/**
 * @deprecated Use `import { RECENT_WORK_CONTEXT, RecentWorkAnalyticsContext } from '@atlaskit/analytics-namespaced-context/RecentWorkAnalyticsContext'` instead.
 */
export { RECENT_WORK_CONTEXT, RecentWorkAnalyticsContext } from './RecentWorkAnalyticsContext';

/**
 * @deprecated Use `import { ATLAS_CONTEXT, AtlasAnalyticsContext } from '@atlaskit/analytics-namespaced-context/AtlasAnalyticsContext'` instead.
 */
export { ATLAS_CONTEXT, AtlasAnalyticsContext } from './AtlasAnalyticsContext';

/**
 * @deprecated Use `import { TOWNSQUARE_HOME_CONTEXT, TownsquareHomeAnalyticsContext } from '@atlaskit/analytics-namespaced-context/TownsquareHomeAnalyticsContext'` instead.
 */
export {
	TOWNSQUARE_HOME_CONTEXT,
	TownsquareHomeAnalyticsContext,
} from './TownsquareHomeAnalyticsContext';

/**
 * @deprecated Use `import { LINKING_PLATFORM_CONTEXT, LinkingPlatformAnalyticsContext } from '@atlaskit/analytics-namespaced-context/LinkingPlatformAnalyticsContext'` instead.
 */
export {
	LINKING_PLATFORM_CONTEXT,
	LinkingPlatformAnalyticsContext,
} from './LinkingPlatformAnalyticsContext';

/**
 * @deprecated Use `import { POST_OFFICE_CONTEXT, PostOfficeAnalyticsContext } from '@atlaskit/analytics-namespaced-context/PostOfficeAnalyticsContext'` instead.
 */
export { POST_OFFICE_CONTEXT, PostOfficeAnalyticsContext } from './PostOfficeAnalyticsContext';

/**
 * @deprecated Use `import { AI_MATE_CONTEXT, AIMateAnalyticsContext } from '@atlaskit/analytics-namespaced-context/AIMateAnalyticsContext'` instead.
 */
export { AI_MATE_CONTEXT, AIMateAnalyticsContext } from './AIMateAnalyticsContext';

/**
 * @deprecated Use `import { AVP_CONTEXT, AVPAnalyticsContext } from '@atlaskit/analytics-namespaced-context/AVPAnalyticsContext'` instead.
 */
export { AVP_CONTEXT, AVPAnalyticsContext } from './AVPAnalyticsContext';

/**
 * @deprecated Use `import { GROWTH_CONTEXT, GrowthAnalyticsContext } from '@atlaskit/analytics-namespaced-context/GrowthAnalyticsContext'` instead.
 */
export { GROWTH_CONTEXT, GrowthAnalyticsContext } from './GrowthAnalyticsContext';

/**
 * @deprecated Use `import { OMNI_CHANNEL_CONTEXT, OmniChannelAnalyticsContext } from '@atlaskit/analytics-namespaced-context/OmniChannelAnalyticsContext'` instead.
 */
export { OMNI_CHANNEL_CONTEXT, OmniChannelAnalyticsContext } from './OmniChannelAnalyticsContext';

/**
 * @deprecated Use `import { ROVO_EXTENSION_CONTEXT, RovoExtensionAnalyticsContext } from '@atlaskit/analytics-namespaced-context/RovoExtensionAnalyticsContext'` instead.
 */
export {
	ROVO_EXTENSION_CONTEXT,
	RovoExtensionAnalyticsContext,
} from './RovoExtensionAnalyticsContext';
